var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 141659"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.941 12.154a10.727 10.727 0 0 1-8.169 10.442 10.5 10.5 0 0 1-11.851-5.7.992.992 0 0 1 .24-1.273.946.946 0 0 1 .8-.174.964.964 0 0 1 .641.517 8.534 8.534 0 0 0 7.775 4.999 8.675 8.675 0 0 0 8.4-6.684 8.874 8.874 0 0 0-4.348-9.915A8.524 8.524 0 0 0 5.945 6.28H8.49a1.013 1.013 0 0 1 1.008.832.992.992 0 0 1-.225.789.952.952 0 0 1-.735.337H3.737a.97.97 0 0 1-.96-.979V2.412a1.023 1.023 0 0 1 .816-1.028.948.948 0 0 1 .774.229.988.988 0 0 1 .33.75v2.4a10.42 10.42 0 0 1 11.58-2.618 10.769 10.769 0 0 1 6.662 10.008Z",
    "data-name": "Path 47816"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetWhite);
export default __webpack_public_path__ + "static/media/Reset_white.2324febb255e076636814a266a4f3bd9.svg";
export { ForwardRef as ReactComponent };